import { useAuth } from "../auth/useAuth";
import { UserRole } from "../enums/UserRole";

export const useHasRole = (role: UserRole) => {
  const { hasRole } = useAuth();
  return hasRole(role);
};

export const useHasAdminRole = () => useHasRole(UserRole.Admin);
